// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes content_loader {
  from {
    background-color: hsl(0, 0%, 90%);
    color: hsl(0, 0%, 90%);
  }

  to {
    background-color: hsl(0, 0%, 95%);
    color: hsl(0, 0%, 95%);
  }
}
`, "",{"version":3,"sources":["webpack://./css/content_loader.css"],"names":[],"mappings":"AAAA;EACE;IACE,iCAAiC;IACjC,sBAAsB;EACxB;;EAEA;IACE,iCAAiC;IACjC,sBAAsB;EACxB;AACF","sourcesContent":["@keyframes content_loader {\n  from {\n    background-color: hsl(0, 0%, 90%);\n    color: hsl(0, 0%, 90%);\n  }\n\n  to {\n    background-color: hsl(0, 0%, 95%);\n    color: hsl(0, 0%, 95%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
